import { render, staticRenderFns } from "./SignoutIcon.vue?vue&type=template&id=780138d0&"
import script from "./SignoutIcon.vue?vue&type=script&lang=ts&"
export * from "./SignoutIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports